import React, { useState } from "react";
import { DestinationService, LoginService, TrackService } from "./client";
import moment from "moment";
import dayjs from "dayjs";
import { isInstalledApp, getMinBookableDate } from "./utils/utils.";
import _ from "lodash";


export type State = {
  loadingTours: boolean,
  loadingMore: boolean,
  hasMoreTours: boolean,
  loadMoreTours: () => void,
  tours: any[];
  destinations: any[];
  start: any,
  end: any,
  myPos: any,
  chartList: any,
  selectedLang: string,
  searchString: string,
  preferiteList: any,
  userInfos: any,
  currency: any,
  installedApp: any,
  account: any,
  setCurrency: (i: any) => void,
  setUserInfos: (i: any) => void,
  savePreferite: (t: any) => void,
  setSearchString:(s: string) => void,
  setSelectedLang:(s: string) => void,
  removeFromChecklist:(v: any) => void,
  setMyPos: (v: any) => void,
  setStart: (v: any) => void,
  setEnd: (v: any) => void,
  addToChart: (p: any) => void,
  setGoogleLoginToken: (t: any) => void
};

// Paginazione lista tour (DEVE combaciare col backend api/views/tracks.py):
// pagina 0 = 40 tour, pagine successive = 20, la cache client si ferma a 5
// pagine (40 + 20*4 = 120 tour massimi tenuti in memoria/localStorage).
const FIRST_PAGE_SIZE = 40;
const NEXT_PAGE_SIZE = 20;
const MAX_CLIENT_PAGES = 5;
const MAX_CLIENT_TOURS = FIRST_PAGE_SIZE + NEXT_PAGE_SIZE * (MAX_CLIENT_PAGES - 1);

export const StateContext = React.createContext<State | null>(null);

const mockDestination = [
  {
      "id": 7,
      "name": "Isola d'Elba",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/64037abd-5ee1-4744-bfde-7a5cf8190789.jpg",
      "count": 1
  },
  {
      "id": 35,
      "name": "Chianti",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/a3d9c7e3-9247-4b7e-a512-de907eb90d08.jpg",
      "count": 5
  },
  {
      "id": 36,
      "name": "Val d'Orcia",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/2662edaa-7e81-44e7-a06e-23c2aff20e9b.jpeg",
      "count": 4
  },
  {
      "id": 5,
      "name": "Riviera Romagnola",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/fb7b2dee-e5ee-40a4-945e-9a541e9338a2.jpg",
      "count": 2
  },
  {
      "id": 2,
      "name": "Dolomiti",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/fedfcc6e-70e7-467a-9a6b-71aa9e95ce2d.jpeg",
      "count": 3
  },
  {
      "id": 4,
      "name": "Siena",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/5c3d4a97-a64f-4159-9956-ac1304d3f235.jpg",
      "count": 2
  },
  {
      "id": 34,
      "name": "Vinci",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/d80d00fb-77bc-4656-938a-593994710eb6.jpg",
      "count": 1
  },
  {
      "id": 6,
      "name": "Maremma",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/f4c951b6-eba8-4345-84a9-ef4245157b99.jpeg",
      "count": 5
  },
  {
      "id": 40,
      "name": "Lunigiana e Garfagnana",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/7c711a32-de27-4fc2-b175-52f8bf5110d0.jpeg",
      "count": 0
  },
  {
      "id": 3,
      "name": "Pisa",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/2f45fd0c-dc2e-4bf2-8776-704e8ce38888.jpg",
      "count": 3
  },
  {
      "id": 37,
      "name": "San Gimignano",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/002536c5-082b-4ed8-81b2-18b624f0a3ce.jpg",
      "count": 1
  },
  {
      "id": 39,
      "name": "Firenze",
      "photo": "https://padbike-admin.s3.amazonaws.com/destination_photo/0a99fda7-75de-4656-824d-c0f9851e2dd4.jpeg",
      "count": 2
  }
]

const StateProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tours, setTours] = React.useState<any[]>([]);
  const [start, _setStart] = React.useState<any>();
  const [end, _setEnd] = React.useState<any>();
  const [myPos, _setMyPos] = React.useState<any>();
  const [selectedLang, _setSelectedLang] = React.useState<string>(window.lang);
  const [chartList, setChartList] = React.useState<any>([]);
  const [preferiteList, setPreferiteList] = React.useState<any>([]);
  const [destinations, setDestinations] =  React.useState<any[]>([]);
  const [loadingTours, setLoadingTours] = React.useState<any>(undefined);
  const [toursPage, setToursPage] = React.useState<number>(0);
  const [hasMoreTours, setHasMoreTours] = React.useState<boolean>(true);
  const [loadingMore, setLoadingMore] = React.useState<boolean>(false);
  const [searchString, setSearchString] = React.useState<string>("");
  const [userInfos, _setUserInfos] = React.useState<any>({})
  const [currency, _setCurrency] = React.useState<any>("eur")
  const [installedApp, setInsalledApp] = React.useState<boolean>(false)
  const [googleToken, setGoogleToken] = React.useState<any>();
  const [account, _setAccount] = React.useState<any>();
  const defaultImage = "data:image/jpeg;base64,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"

  const apiCalls = () => {
    setLoadingTours(true);
    // Sul pannello manager (/manager/:token) non servono le destinazioni né
    // i tour pubblici: evitiamo le chiamate inutili destination_list e
    // public_tracks. Usiamo window.location perché lo StateProvider è
    // montato fuori dal BrowserRouter (niente useLocation qui).
    if (window.location.pathname.startsWith("/manager")) {
      setLoadingTours(false);
      return;
    }
    DestinationService.list()
    .then(data => {
      let resp = _.shuffle(data);
      setDestinations(resp);
      updateLocalstorage("destinations", structuredClone(resp))
    }).catch(() => {
      let resp = _.shuffle(mockDestination);
      setDestinations(resp);
      updateLocalstorage("destinations", structuredClone(resp));
    })
    
    setTimeout(() => {
      if(account) {
        LoginService.updateAccount()
      }
    }, 1000);

    TrackService.list(0)
    .then((resp: any) => {
      setTours(resp);
      setToursPage(0);
      // Se la prima pagina è piena potrebbero esserci altre pagine da caricare.
      setHasMoreTours(resp.length >= FIRST_PAGE_SIZE);
      persistTours(resp)
      setLoadingTours(false);
    })
    .catch((e: any) => {
      console.log(e);
      setLoadingTours(false);
    });
  }

  // Salva i tour in localStorage rimuovendo le immagini base64 pesanti dei POI
  // e limitando al massimo di cache client (5 pagine, 150 tour).
  const persistTours = (list: any[]) => {
    const copy = structuredClone(list.slice(0, MAX_CLIENT_TOURS))
    copy.forEach((t: any) => {
      (t.routes || []).forEach((r: any) => {
        r.pois = (r.pois || []).map((p: any) => ({ ...p, image: defaultImage }))
      });
    });
    updateLocalstorage("tours", copy)
  }

  // "Carica altri tour": chiede la pagina successiva (20 risultati) e la
  // accoda ai tour già presenti, senza duplicati. Si ferma a 5 pagine o quando
  // il server ritorna meno di una pagina piena.
  const loadMoreTours = () => {
    if (loadingMore || !hasMoreTours) return;
    const nextPage = toursPage + 1;
    setLoadingMore(true);
    TrackService.list(nextPage)
      .then((resp: any) => {
        setTours((prev: any[]) => {
          const existing = new Set(prev.map((t: any) => t.id));
          const merged = [...prev, ...resp.filter((t: any) => !existing.has(t.id))];
          persistTours(merged);
          return merged;
        });
        setToursPage(nextPage);
        if (resp.length < NEXT_PAGE_SIZE || nextPage >= MAX_CLIENT_PAGES - 1) {
          setHasMoreTours(false);
        }
        setLoadingMore(false);
      })
      .catch(() => setLoadingMore(false));
  }

  if (loadingTours === undefined) {
    // JSON.parse NON protetto = se outdooraData è corrotto/troncato sul device
    // (quota, eviction del WebView in-app, ecc.) l'INTERA app va in crash prima
    // di montare -> pagina bianca su OGNI rotta, incluso /manager. Proteggiamo
    // il parse e ripuliamo il dato corrotto invece di far crashare tutto.
    let data: any = null;
    try {
      if (localStorage.outdooraData) {
        data = JSON.parse(localStorage.outdooraData)
      }
    } catch (e) {
      console.warn("outdooraData corrotto: lo ripulisco", e)
      try { localStorage.removeItem("outdooraData") } catch (e2) { /* ignore */ }
      data = null;
    }
    if(data) {
      if(data.tours) {
        setTours(data.tours)
      }
      if(data.destinations) {
        setDestinations(data.destinations)
      }
      if (data.currency) {
        _setCurrency(data.currency)
      }
      if (data.start) {
        // Riprendo la data salvata solo se è ancora prenotabile secondo il
        // cutoff (10h prima della fascia oraria del tour).
        const minDate = getMinBookableDate(dayjs())
        if(dayjs(new Date(data.start).getTime()).startOf('day') >= minDate) {
          _setStart(dayjs(data.start))
        }
      }
      if (data.chartList) {
        setChartList(data.chartList)
      }
      if (data.preferiteList) {
        setPreferiteList(data.preferiteList)
      }
      if (data.language) {
        _setSelectedLang(data.language || 'it')
        window.lang = data.language
      }
      if(data.userInfos) {
        _setUserInfos(data.userInfos)
      }
      if(data.google_token) {
        setGoogleToken(data.google_token)
      }
      if(data.account) {
        _setAccount(data.account)
      }
    }
    apiCalls();
    
    isInstalledApp(() => {
      setInsalledApp(true)
    }, () => {
      setInsalledApp(false)
    })

  }

  const updateLocalstorage = (key: any, v: any) => {
    let data;
    if(localStorage.outdooraData) {
      data = JSON.parse(localStorage.outdooraData)
      data[key] = v
    } else {
      data = {
        [key]: v
      }
    }
    localStorage.outdooraData = JSON.stringify(data)
  }

  const setStart = (v: any) => {
    _setStart(v);
    updateLocalstorage("start", v.format())
  }

  const setEnd = (v: any) => {
    _setEnd(v);
  }

  const setMyPos = (p: any) => {
    _setMyPos(p)
  }

  const setUserInfos = (i: any) => {
    _setUserInfos(i)
    updateLocalstorage('userInfos', i)
  }

  const setAccount = (a: any) => {
    _setAccount(a)
    updateLocalstorage('account', a)
  }

  const setSelectedLang = (l: string) => {
    if (selectedLang !== l) {
      _setSelectedLang(l);
      window.lang = l;
      updateLocalstorage('language', l)
      apiCalls()
    }
  }

  const setGoogleLoginToken = (credential: any) => {
    console.log(credential); // This is the ID token
    // Send this credential to your Python backend
    LoginService.login(credential, userInfos).then((accountInfos: any) => {
      setGoogleToken(credential)
      updateLocalstorage('google_token', credential)
      setAccount(accountInfos)
    });
  }

  const addToChart = (pack: any) => {
    const _chartList =  structuredClone(chartList)
    _chartList.push(pack)
    setChartList(_chartList)
    updateLocalstorage("chartList", _chartList)
  }

  const removeFromChecklist = (i: number) => {
    const _chartList =  structuredClone(chartList)
    _chartList.splice(i, 1)
    setChartList(_chartList)
    updateLocalstorage("chartList", _chartList)
  }

  const savePreferite = (t: any) => {
    const _preferiteList = structuredClone(preferiteList)
    const index = _preferiteList.findIndex((t2:any) => t2.id === t.id)
    if(index !== -1) {
      _preferiteList.splice(index, 1)
    } else {
      _preferiteList.push(t)
    }
    setPreferiteList(_preferiteList)
    updateLocalstorage("preferiteList", _preferiteList)
  }
  const setCurrency = (c:any) => {
    _setCurrency(c)
    updateLocalstorage("currency", c)
  }

  return (
    <StateContext.Provider
      value={{
        loadingTours,
        loadingMore,
        hasMoreTours,
        loadMoreTours,
        tours,
        destinations,
        start,
        end,
        myPos,
        chartList,
        selectedLang,
        searchString,
        preferiteList,
        userInfos,
        currency,
        installedApp,
        account,
        setGoogleLoginToken,
        setCurrency,
        setUserInfos,
        setSearchString,
        setSelectedLang,
        removeFromChecklist,
        addToChart,
        setMyPos,
        setStart,
        setEnd,
        savePreferite
      }}
    >
      {children}
    </StateContext.Provider>
  );
};


export default StateProvider;
